import Vue from 'vue'

const common = {
  namespaced: true,
  state: {
    env: {},
    envs: [
      { code: 'development', name: '(QA) Ambiente de prueba' },
      { code: 'production', name: '(PRD) Ambiente de producción' }
    ]
  },
  actions: {
    updateEnv ({ commit }, env) {
      commit('SET_ENV', env)
    }
  },
  mutations: {
    SET_ENV (state, data) {
      Vue.set(state, 'env', data)
    }
  },
  getters: {
    envsInfo: state => state.envs,
    envInfo: state => state.env
  }
}

export default common



// WEBPACK FOOTER //
// ./src/store/modules/common.js